import { render, staticRenderFns } from "./PanelCol.vue?vue&type=template&id=8114f564&"
import script from "./PanelCol.vue?vue&type=script&lang=js&"
export * from "./PanelCol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports